export default {
  namespaced: true,
  state: {
    forceSyncSettingToSchool: false,
  },
}
